import api from '@/apis/fr/frColumnListAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('FrColumnList', api);

const state = {
  ...crud.state,
  _config: {
    table: 'fr_column_list',
    field: {
      key: 'fr_column_list_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Update multiple
   * nmtuan4 15.9.2022
   */
  async addAndUpdateMultiple(context, param) {
    let res = await api.addAndUpdateMultiple(param);

    //HTHIEP 08.07.2022: Update lại state khi cập nhật dữ liệu
    context.commit('setItems', []);
    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
